module.exports = __webpack_public_path__ + "static/media/icons.4c0a6345.svg";